// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 777) return "static/js/recorder.b246fb46e.chunk.js";
	if (chunkId === 12) return "static/js/profiler.b246fb46e.chunk.js";
	if (chunkId === 31) return "static/js/31.b246fb46e.chunk.js";
	if (chunkId === 625) return "static/js/625.b246fb46e.chunk.js";
	if (chunkId === 160) return "static/js/160.b246fb46e.chunk.js";
	if (chunkId === 103) return "static/js/103.b246fb46e.chunk.js";
	if (chunkId === 177) return "static/js/177.b246fb46e.chunk.js";
	// return url for filenames based on template
	return undefined;
};